import React from 'react';
import { Controller } from 'react-hook-form';
import Select from 'react-select';
import { FormLabel } from './FormLabel';

const FormSelect = ({
  control,
  name,
  id,
  label,
  rules,
  options,
  isMulti = false,
  placeholder,
  defaultValue,
  onChange: externalOnChange,
  ...props
}) => {
  return (
    <div id={id}>
      {label && <FormLabel rules={rules} label={label} id={id} />}
      <Controller
        name={name}
        control={control}
        rules={rules}
        defaultValue={defaultValue}
        render={({ field, fieldState }) => (
          <>
            <Select
              {...field}
              id={id}
              options={options}
              isMulti={isMulti}
              placeholder={placeholder}
              //value={options.find((option) => option.value === field.value)}
              onChange={(value) => {
                // Ensure the new value is set in react-hook-form's state
                field.onChange(value);
                // Call external onChange if any
                if (externalOnChange) externalOnChange(value);
              }}
              onBlur={field.onBlur}
              {...props}
            />
            {fieldState.invalid && <div className="text-danger">{fieldState.error?.message}</div>}
          </>
        )}
      />
    </div>
  );
};

export default FormSelect;
